import AppConstants from '../config/app.constants';

let MessageService = function ($http, $q) {

    let all = (languageId, search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (languageId, data, branchId) => {
        return $http
            .post(AppConstants.api + `/language/${languageId}/message/create`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let remove = (languageId, id, messageId, type, branchId) => {
        return $http
            .delete(AppConstants.api + `/language/${languageId}/message/${id}`, {
                params: {
                    messageId, 
                    type, 
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (languageId, id, data, branchId) => {
        return $http
            .post(AppConstants.api + `/language/${languageId}/message/${id}`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let get = (languageId, id) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getDuplicateMsg = (languageId, searchText, messageType, offset, limit) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/duplicate-msg`, {
                params: {
                    languageId,
                    searchText,
                    messageType,
                    offset, 
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getReasons = (languageId, routeVerifyData) => {
        return $http
            .post(AppConstants.api + `/language/${languageId}/message/route-reasons`, routeVerifyData)
            .then((res) => {
                return res.data
            })
    }

    let updateLanguageMessage = (languageId, data) => {
        return $http
            .post(AppConstants.api + `/language/${languageId}/message/update-language-message`, { data })
            .then((res) => {
                return res.data
            })
    }

    let getPendingMessage = (languageId) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/pending-msg`)
            .then((res) => {
                return res.data
            })
    }

    let getMessageTypeBuckets = (searchText, languageId) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/get-message-type-buckets`, {
                params: {
                    searchText,
                    languageId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getLanguageMessages = (searchText, languageId, messageType, limit, offset) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/get-language-message`, {
                params: {
                    searchText,
                    languageId,
                    messageType,
                    limit, 
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getMessageByMessageId = (languageId, messageId, messageType) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/get-message-by-message-id`, {
                params: {
                    messageId, 
                    messageType
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentDeleteReason = (type, languageId) => {
        return $http
            .get(AppConstants.api + `/language/${languageId}/message/shipment-delete-reason`, {
                params: { type, languageId }
            })
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        create,
        remove,
        update,
        get,
        getDuplicateMsg,
        getReasons,
        updateLanguageMessage,
        getPendingMessage,
        getMessageTypeBuckets,
        getLanguageMessages,
        getMessageByMessageId,
        shipmentDeleteReason
    };
};

MessageService.$inject = ['$http', '$q']

export default MessageService;


// WEBPACK FOOTER //
// ./client/app/services/message.service.js